module.exports = __webpack_public_path__ + "img/pic_network_anomaly.bfc4d000.png";